if (!customElements.get('piecework-view-buttons')) {
  customElements.define(
    'piecework-view-buttons',
    class PieceworkViewButtons extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          buttons: this.querySelectorAll('.pw-view-by-button'),
          grid: document.querySelector('.product-grid-container'),
        };

        if (!this.elements.buttons || !this.elements.grid) return;

        this.elements.buttons.forEach((e) => {
          const type = e.dataset.viewby;
          e.addEventListener('click', this.changeImageType.bind(this, type));
        });
      }

      changeImageType(type) {
        this.elements.grid.dataset.viewby = type;
        this.elements.buttons.forEach((e) => {
          if (e.dataset.viewby === type) {
            e.classList.add('pw-viewby-active');
          } else {
            e.classList.remove('pw-viewby-active');
          }
        });
        localStorage.setItem('pw-viewby', type);
      }

      connectedCallback() {
        const localViewType = localStorage.getItem('pw-viewby');
        if (localViewType) {
          this.changeImageType(localViewType);
        } else {
          this.changeImageType(this.elements.buttons[0].dataset.viewby);
        }
      }
    }
  );
}
